import { ColumnType } from "../data/column.enum";

/**
 * Extracts the appropriate value from a Monday.com column value based on the column type
 * @param columnType - The type of the column
 * @param latestValue - The raw value from Monday.com
 * @returns The extracted value formatted appropriately for the column type
 */
export const extractColumnValue = (columnType: string, latestValue: any): any => {
  if (!latestValue) return null;

  switch (columnType) {
    case ColumnType.PEOPLE:
    case ColumnType.MULTIPLE_PEOPLE:
    case ColumnType.PERSON:
      return latestValue?.value?.personsAndTeams ? latestValue.value.personsAndTeams.map((person: any) => person.id) : null;

    case ColumnType.STATUS:
    case ColumnType.COLOR:
      return latestValue?.value?.label?.text;

    case ColumnType.DATE:
      return latestValue?.value?.date;

    case ColumnType.HOUR:
      return latestValue?.value ?? latestValue;

    case ColumnType.TEXT:
    case ColumnType.NUMBER:
    case ColumnType.NUMERIC:
      return latestValue?.value?.value;

    case ColumnType.TIMELINE:
      return latestValue?.value?.from && latestValue?.value?.to ? `${latestValue.value.from} - ${latestValue.value.to}` : null;

    case ColumnType.PHONE:
      return latestValue?.value?.phone;

    case ColumnType.EMAIL:
      return latestValue?.value?.email;

    case ColumnType.LINK:
      return latestValue?.value?.url;

    case ColumnType.LONG_TEXT:
      return latestValue?.value?.text;

    case ColumnType.RATING:
      return latestValue?.value?.rating;

    case ColumnType.CHECKBOX:
      return latestValue?.value?.checked;

    case ColumnType.BOARD_RELATION:
      return latestValue?.value?.linkedPulseIds?.map((id: { linkedPulseId: number }) => id.linkedPulseId).join(", ");

    case ColumnType.LOCATION:
      return latestValue?.value?.address;

    case ColumnType.TAG:
      return latestValue?.value?.tags?.map((tag: any) => tag?.name).join(", ");

    case ColumnType.DROPDOWN:
      return latestValue?.value?.chosenValues?.map((choice: any) => choice?.name).join(", ");

    case ColumnType.DOC:
      return JSON.stringify(latestValue);

    default:
      return null;
  }
};
